import { BoundActions, createHook, createStore, HookFunction, StoreActionApi } from 'react-sweet-state';

import { ColumnInfo } from '../types';

interface CustomColumnsState {
	columns: ColumnInfo[];
}

const initialState: CustomColumnsState = {
	columns: [],
};

const customColumnsStore = createStore({
	initialState,
	actions: {
		setColumns:
			(columns?: ColumnInfo[]): (({ setState }: StoreActionApi<CustomColumnsState>) => void) =>
			({ setState }) => {
				setState({ columns: columns ?? [] });
			},
	},
	name: 'custom-columns-store',
});

export const useCustomColumns: HookFunction<
	CustomColumnsState,
	BoundActions<
		CustomColumnsState,
		{
			setColumns: (columns?: ColumnInfo[]) => ({ setState }: StoreActionApi<CustomColumnsState>) => void;
		}
	>,
	void
> = createHook(customColumnsStore);
